/* eslint-disable object-curly-newline */
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';

const SessionExpired = ({ onClick }) => (
  <Dialog open fullWidth>
    <DialogTitle>Session expired</DialogTitle>
    <DialogContent>
      <Typography>
        Your session has expired and were logged out of your account. Please press reload to sign in again.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClick}>Reload</Button>
    </DialogActions>
  </Dialog>
);

export default SessionExpired;
